export default function (options) {
  if(window.gact.disable_download){
    return;
  }
  const mergeOptions = {
    scheme: "imgotv://",
    jumpTo: "https://club.mgtv.com/act/download/index.html?source=" + window.gact.source + '_download',
    ...options
  };
  if (gact.is_wx) {
    window.location = mergeOptions.jumpTo;
    return;
  } else {
    tryOpen();
    setTimeout(function () {
      window.location = mergeOptions.jumpTo;
    }, 1000);
  }
  function tryOpen() {
    var iframe = document.createElement("iframe");
    iframe.src = mergeOptions.scheme;
    iframe.style.display = "none";
    document.body.appendChild(iframe);
  }
}




// WEBPACK FOOTER //
// ./src/tools/mgtv/downapp.js